import clsx from 'clsx'

import IconCross from '@/assets/svg/purge/icons/icon-cross.svg'
import Button from '@/atoms/Button/Button'
import isObjectEmpty from '@/helpers/isObjectEmpty'
import usePriceRange from '@/hooks/usePriceRange'
import Filters from '@/services/Filters/Filters'
import { hideModals } from '@/store/slices/modal'
import { Media } from '@/templates/Media/Media'

import ResetButton from './ResetButton'

function Controls() {
  const currentFilters = Filters.get() || {}
  const priceFilters = usePriceRange()
  const isFilter = !isObjectEmpty({ ...currentFilters, ...priceFilters })

  return (
    <div
      className={clsx(
        'flex items-center border-b min-h-[48px] xl:min-h-0 pb-4 xl:pb-0 mb-6 xl:mb-1 border-gray-5 xl:border-none',
        {
          '!mb-12': isFilter,
        }
      )}
    >
      {isFilter && <ResetButton />}
      <Media className="mb-1 ml-auto" lessThan="xl">
        <Button
          className="w-4 h-4"
          variant="plain"
          icon={<IconCross />}
          onClick={() => hideModals()}
        />
      </Media>
    </div>
  )
}

export default Controls
